// Builder fee configuration and EIP-712 constants
export const BUILDER_FEE_CONFIG = {
  // These should come from GET /api/builder-fee/config at runtime
  // Fallback defaults:
  BUILDER_ADDRESS: import.meta.env.VITE_BUILDER_ADDRESS,
  MAX_FEE_RATE: "0.01%",
  NETWORK: import.meta.env.VITE_HL_NETWORK || "Mainnet",
};

export const APPROVE_BUILDER_FEE_DOMAIN = {
  name: "HyperliquidSignTransaction",
  version: "1",
  chainId: 0x66eee, // 421614
  verifyingContract: "0x0000000000000000000000000000000000000000",
};

export const APPROVE_BUILDER_FEE_TYPES = {
  "HyperliquidTransaction:ApproveBuilderFee": [
    { name: "hyperliquidChain", type: "string" },
    { name: "maxFeeRate", type: "string" },
    { name: "builder", type: "address" },
    { name: "nonce", type: "uint64" },
  ],
};